// extracted by mini-css-extract-plugin
module.exports = {"header__wrapper":"Header_header__wrapper__plCyz","header__image":"Header_header__image__h3_AD","header__h1":"Header_header__h1__s6QQH"};